import { Loader } from 'components/common';
import { lazy, Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { ChainId, ThirdwebSDKProvider } from '@thirdweb-dev/react';
import { useProvider, useSigner, useQueryClient } from 'wagmi';

import CreateProperty from 'pages/CreateProperty';
import VerifyProperty from 'pages/CreateProperty/VerifyProperty';
import Explore from 'pages/Explore';
import Profile from 'pages/Profile';
import PropertyDetails from 'pages/PropertyDetails';
import { wagmiClient } from 'web3/connect';

const HomePage = lazy(() => import('./pages/Home'));

const App = () => {
  const provider = useProvider();
  const { data: signer } = useSigner();
  const query = useQueryClient();

  // console.log('signer:  ', signer);
  // console.log('provider: ', provider);
  // console.log('queryClient: ', wagmiClient.queryClient);

  const activeChainId = ChainId.Mumbai;

  return (
    <ThirdwebSDKProvider
      desiredChainId={activeChainId}
      provider={wagmiClient.provider}
      signer={signer as any}
      queryClient={query as any}
      // signer={wagmiClient.si}
      //   // queryClient={wagmiClient.queryClient as any}
    >
      <BrowserRouter>
        <Suspense fallback={<Loader />}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/profile">
              <Route path=":name" element={<Profile />} />
              <Route path="" element={<Profile />} />
            </Route>
            <Route path="/explore">
              <Route path=":category" element={<Explore />} />
              <Route path="" element={<Explore />} />
            </Route>
            <Route path="/property/create">
              <Route path=":verify" element={<VerifyProperty />} />
              <Route path="" element={<CreateProperty />} />
            </Route>
            <Route path="/property/:slug" element={<PropertyDetails />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </ThirdwebSDKProvider>
  );
};

export default App;
